(function(){
  var MINI_REVIEWS = [
    {text:"In just 7 days I have been able to notice I feel less bloated and my face seems slimmer!", initials:"MK", author:"Maria K., 41 years", tags:["Visible Results","Less Bloated"]},
    {text:"Does what it says been on it for 2 weeks now and have noticed a big difference", initials:"GR", author:"Gary R., 39 years", tags:["Visible Results","Works as Advertised"]},
    {text:"I've noticed a reduction in the bloating of my face almost immediately.", initials:"DC", author:"Danielle C., 37 years", tags:["Less Bloating","Quick Results"]},
    {text:"I've only been using for a week now but all I can say is WOW! Totally amazing. My feet are almost back to normal.", initials:"KE", author:"Kimberly E., 45 years", tags:["Reduced Swelling","Visible Results"]},
    {text:"Great product since using it have been feeling a step ahead!", initials:"JA", author:"Jake A., 49 years", tags:["More Energy","Overall Wellness"]}
  ];
  var miniIdx = 0;
  function renderMini(){
    var r = MINI_REVIEWS[miniIdx];
    var t = document.getElementById('lymAgrMiniText');
    var a = document.getElementById('lymAgrMiniAvatar');
    var au = document.getElementById('lymAgrMiniAuthor');
    var tg = document.getElementById('lymAgrMiniTags');
    if(!t) return;
    t.textContent = '“' + r.text + '”';
    a.textContent = r.initials;
    au.textContent = r.author;
    tg.innerHTML = r.tags.map(function(x){return '<span class="lym-agr-tag">'+x+'</span>';}).join('');
  }
  window.lymAgrShiftMini = function(dir){
    miniIdx = (miniIdx + dir + MINI_REVIEWS.length) % MINI_REVIEWS.length;
    renderMini();
  };

  var MIRROR_BY_CAT = {
    bloating: [
      {text:"Just taking it for few days I feel the difference. No bloating. I have to continue with taking it so I can see more changes. Thank you I really happy with my product.", author:"Sunita A., 33 years"},
      {text:"I started taking it daily in my water, and it's made such a difference. Less bloating, smoother digestion, and my skin has a glow I haven't seen in years. I feel lighter, inside and out.", author:"Chloe W., 35 years"},
      {text:"I've noticed a difference when I use the bathroom. It actually has a nice taste to it. I'm noticing that the bloating is not as bad and I'm sure it will get better. I've noticed a lot in just the few days since I started taking it and I'm very satisfied because if it's working like this in such a short time I can just imagine how I will look and feel in a couple of months. Thank you and I will keep in touch.", author:"Pancho P., 39 years"},
      {text:"Wasn't expecting to get noticeable results from the Nuflos as quickly as I did.. within 2 weeks bloating around my mid section was reduced and I have been sleeping better since starting.. delivery was around 7 days from ordering so not terrible.. I also actually like the taste just to cap things off.", author:"Daniel B., 48 years"}
    ],
    swelling: [
      {text:"After a week, my face looks slimmer and my eyes aren't swollen anymore. I wake up looking refreshed instead of tired.", author:"Jessica R., 33 years"},
      {text:"My legs and ankles used to swell after sitting at my desk all day. After starting Nuflos, the heaviness is gone. I feel lighter, my circulation feels better, and even my skin looks more even-toned.", author:"Lauren H., 41 years"},
      {text:"I love how gentle this formula is. It's not a harsh cleanse, it just helps everything flow better. My skin looks clearer, my eyes are less swollen, and I feel like my body is finally balanced again.", author:"Samantha D., 29 years"},
      {text:"I purchased the item because my face was swollen and I have been dealing with allergies since March. After a few weeks, I see my cheeks aren't as puffy. I use the drops before going to work and before going to bed. I personally like the taste of the drops, yet it's does have a peculiar taste. I usually drink some water after I take the drops. I definitely would recommend Nuflos to anyone dealing with allergies.", author:"Shamir B., 37 years"}
    ],
    energy: [
      {text:"I notice the difference in my energy levels. My bloating reduced too. Skin clearing up and I'm not as stuffy in the morning.", author:"Dennis H., 52 years"},
      {text:"Man! I ordered this product based on the reviews and it is amazing! It has me feeling good after 1 week of using this product. I've been telling everyone how good it works.", author:"Walter L., 39 years"},
      {text:"I suddenly am able to breathe through both nostrils. It's been a chronic hindrance for decades, making my nose crooked enough that my two profiles look quite different. Wow. And today I have tons of energy. And I am happy. Not slightly depressed, as usual. Patient, not agitated. Relaxed, not driven. Wow, again. I have only just started the drops this past week! It actually is bonafide. Not snake oil.", author:"Liesje, 41 years"},
      {text:"Its been a great experience so far. The first thing is the taste. I was bracing myself for something bitter or some other medicinal taste. I was surprised that it tasted sweet but not a sugar sweet and honey/natural light sweetness. The second effect was an almost immediate boost in energy throughout the day. I am definitely going to recommend to my family and friends.", author:"Cameron B., 33 years"}
    ]
  };
  var mirrorCat = 'bloating';
  var mirrorIdx = 0;
  function renderMirror(){
    var list = MIRROR_BY_CAT[mirrorCat];
    var r = list[mirrorIdx];
    var t = document.getElementById('lymAgrMirrorText');
    var au = document.getElementById('lymAgrMirrorAuthor');
    var dotsWrap = document.getElementById('lymAgrMirrorDots');
    if(!t) return;
    t.textContent = '“' + r.text + '”';
    au.textContent = r.author;
    var dotEls = dotsWrap.children;
    for (var i = 0; i < dotEls.length; i++) {
      if (i === mirrorIdx) { dotEls[i].classList.add('lym-agr-active'); }
      else { dotEls[i].classList.remove('lym-agr-active'); }
    }
  }
  window.lymAgrSetMirrorCategory = function(cat, btn){
    mirrorCat = cat;
    mirrorIdx = 0;
    var chips = btn.parentElement.querySelectorAll('.lym-agr-filter-chip');
    for(var i=0;i<chips.length;i++){ chips[i].classList.remove('lym-agr-active'); }
    btn.classList.add('lym-agr-active');
    renderMirror();
  };
  window.lymAgrShiftMirror = function(dir){
    var list = MIRROR_BY_CAT[mirrorCat];
    mirrorIdx = (mirrorIdx + dir + list.length) % list.length;
    renderMirror();
  };

  var REASONS = [
    {n:1, img:"lym-reason-1.png", title:"De-Puffs from Within", text:"Unlike typical detox blends, Nuflos supports healthy lymphatic flow to help your body release excess fluid, reduce swelling, and restore natural balance."},
    {n:2, img:"lym-reason-2.png", title:"Promotes Whole-Body Balance", text:"A blend of herbal actives like Cleavers, Red Clover, and Stillingia Root work together to support circulation, digestion, and natural energy for complete internal balance."},
    {n:3, img:"lym-reason-3.png", title:"Gentle Yet Effective", text:"Unlike harsh cleanses or diuretics, this formula supports daily drainage and detox without dehydration or discomfort, just a light, refreshed feeling every day."},
    {n:4, img:"lym-reason-4.png", title:"Clean, Verified Ingredients", text:"Made with 100% plant-based extracts, free from alcohol, sugar, gluten, or additives. Formulated in the USA."},
    {n:5, img:"lym-reason-5.png", title:"Results You Can See & Feel", text:"Most customers notice visible changes in 7–14 days: smoother skin, less swelling, and renewed energy. Consistent use brings steady, lasting balance."}
  ];
  var reasonIdx = 0;
  function renderReason(){
    var r = REASONS[reasonIdx];
    var img = document.getElementById('lymAgrReasonImg');
    if(!img) return;
    img.src = img.getAttribute('data-base') + r.img;
    document.getElementById('lymAgrReasonBadge').textContent = 'Reason ' + r.n;
    document.getElementById('lymAgrReasonTitle').textContent = r.title;
    document.getElementById('lymAgrReasonText').textContent = r.text;
    document.getElementById('lymAgrReasonDots').innerHTML = REASONS.map(function(_, i){return '<span class="'+(i===reasonIdx?'lym-agr-active':'')+'"></span>';}).join('');
  }
  window.lymAgrShiftReason = function(dir){
    reasonIdx = (reasonIdx + dir + REASONS.length) % REASONS.length;
    renderReason();
  };

  var lymAgrPurchaseType = 'onetime';

  var CC_CHECKOUT_URL = "https://get.nuflos.com/ck-3.2-ww";
  var CC_CAMPAIGN_ID = "2";

  function lymAgrCcRedirect(ccId){
    if(!ccId) return;
    var url = CC_CHECKOUT_URL + "?products=" + encodeURIComponent(ccId) + ":1&campaignId=" + CC_CAMPAIGN_ID;
    if(window.location.search){
      var dest = new URL(url);
      new URLSearchParams(window.location.search).forEach(function(value, key){
        dest.searchParams.set(key, value);
      });
      url = dest.toString();
    }
    var dest = new URL(url);
    dest.searchParams.set("cc_custom_landing", decodeURIComponent(window.location.pathname.split("/").pop()));
    url = dest.toString();
    // CheckoutChamp: attach cart attributes (Intelligems etc.) via assets/c-cc-attribution.js
    if (window.ccGo) window.ccGo(url); else window.location.href = url;
  }

  window.lymAgrCheckout = function(e, ctaEl){
    if(e) e.preventDefault();
    var section = ctaEl.closest('section') || document.getElementById('pricing-mobile');
    if(!section) return;
    var selectedCard = section.querySelector('.lym-pricing-card.lym-agr-selected') || section.querySelector('.lym-pricing-card');
    if(!selectedCard) return;
    var hasToggle = !!section.querySelector('.lym-purchase-toggle');
    var ccId;
    if(hasToggle && lymAgrPurchaseType === 'onetime'){
      ccId = selectedCard.getAttribute('data-cc-onetime') || selectedCard.getAttribute('data-cc-sub');
    } else {
      ccId = selectedCard.getAttribute('data-cc-sub');
    }
    lymAgrCcRedirect(ccId);
  };

  function lymAgrApplyCtaPricing(cardEl, section){
    if(!cardEl || !section) return;
    var priceEl = section.querySelector('.lym-agr-cta-price');
    var wasEl = section.querySelector('.lym-agr-cta-was');
    var hasToggle = !!section.querySelector('.lym-purchase-toggle');
    if(hasToggle && lymAgrPurchaseType === 'onetime'){
      var priceOnetime = cardEl.getAttribute('data-price-onetime') || cardEl.getAttribute('data-was');
      if(priceEl) priceEl.textContent = priceOnetime;
      if(wasEl){ wasEl.style.display = 'none'; }
    } else {
      var price = cardEl.getAttribute('data-price');
      var was = cardEl.getAttribute('data-was');
      if(priceEl) priceEl.textContent = price;
      if(wasEl){ wasEl.textContent = was; wasEl.style.display = ''; }
    }
  }

  function lymAgrApplyPurchaseTypeToCards(section){
    var cards = section.querySelectorAll('.lym-pricing-card');
    var hasToggle = !!section.querySelector('.lym-purchase-toggle');
    cards.forEach(function(c){
      var nowEl = c.querySelector('.lym-price-now');
      var wasEl = c.querySelector('.lym-price-was');
      if(!nowEl) return;
      if(hasToggle && lymAgrPurchaseType === 'onetime'){
        var priceOnetime = c.getAttribute('data-price-onetime') || c.getAttribute('data-was');
        nowEl.textContent = priceOnetime;
        if(wasEl){ wasEl.style.display = 'none'; }
      } else {
        nowEl.textContent = c.getAttribute('data-price');
        if(wasEl){ wasEl.textContent = c.getAttribute('data-was'); wasEl.style.display = ''; }
      }
    });
  }

  window.lymAgrSelectPricing = function(cardEl){
    var grid = cardEl.closest('.lym-pricing-grid');
    if(!grid) return;
    var cards = grid.querySelectorAll('.lym-pricing-card');
    cards.forEach(function(c){ c.classList.remove('lym-agr-selected'); });
    cardEl.classList.add('lym-agr-selected');
    var section = grid.closest('section');
    if(!section) return;
    lymAgrApplyCtaPricing(cardEl, section);
    var choiceTitle = cardEl.getAttribute('data-choice-title');
    var choiceText = cardEl.getAttribute('data-choice-text');
    if(choiceTitle && choiceText){
      var goodChoice = section.querySelector('.lym-good-choice');
      if(goodChoice){
        var titleEl = goodChoice.querySelector('.lym-good-choice-title');
        var descEl = goodChoice.querySelector('.lym-good-choice-desc');
        if(titleEl) titleEl.textContent = choiceTitle;
        if(descEl) descEl.innerHTML = choiceText.replace(/(&euro;[\d.,]+|\$[\d.,]+|€\s?[\d.,]+)/, '<span class="lym-good-choice-amount">$1</span>');
      }
    }
    var deliveryText = cardEl.getAttribute('data-delivery');
    if(deliveryText){
      var deliveryEl = section.querySelector('.lym-pdi-delivery-value');
      if(deliveryEl) deliveryEl.textContent = deliveryText;
    }
    var weeksText = cardEl.getAttribute('data-weeks');
    if(weeksText){
      var weeksEl = section.querySelector('.lym-agr-delivery-weeks');
      if(weeksEl) weeksEl.textContent = weeksText + ' weeks';
    }
  };

  window.lymAgrSetPurchaseType = function(type, btn){
    lymAgrPurchaseType = type;
    var section = btn ? btn.closest('section') : null;
    if(!section) return;
    var toggleBtns = section.querySelectorAll('.lym-toggle-btn');
    toggleBtns.forEach(function(b){ b.classList.remove('lym-toggle-btn--active'); });
    if(btn) btn.classList.add('lym-toggle-btn--active');
    lymAgrApplyPurchaseTypeToCards(section);
    var selectedCard = section.querySelector('.lym-pricing-card.lym-agr-selected') || section.querySelector('.lym-pricing-card');
    if(selectedCard) lymAgrApplyCtaPricing(selectedCard, section);
  };

  function lymAgrInitShipDate(){
    var els = document.querySelectorAll('.lym-agr-shipdate-value');
    if(!els.length) return;
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var d = new Date();
    d.setDate(d.getDate() + 7);
    var day = d.getDate();
    var suffix = 'th';
    if(day % 10 === 1 && day !== 11) suffix = 'st';
    else if(day % 10 === 2 && day !== 12) suffix = 'nd';
    else if(day % 10 === 3 && day !== 13) suffix = 'rd';
    var text = months[d.getMonth()] + ' ' + day + suffix;
    els.forEach(function(el){ el.textContent = text; });
  }

  function lymAgrInitTimelineScroll(){
    var items = document.querySelectorAll('.lym-agr-timeline-section .lym-agr-timeline-week');
    if(!items.length) return;
    function isPastMiddle(el){
      var rect = el.getBoundingClientRect();
      if(rect.width === 0 && rect.height === 0) return null;
      var viewportMid = window.innerHeight / 2;
      return rect.bottom <= viewportMid + 100;
    }
    function update(){
      items.forEach(function(el){
        var past = isPastMiddle(el);
        if(past === null) return;
        if(past) el.classList.add('lym-agr-active');
        else el.classList.remove('lym-agr-active');
      });
    }
    window.addEventListener('scroll', update, {passive:true});
    document.querySelectorAll('.lym-faq2b-tab-input').forEach(function(input){
      input.addEventListener('change', function(){
        requestAnimationFrame(update);
      });
    });
    update();
  }

  function lymAgrInitStickyBar(){
    var bar = document.querySelector('.lym-sticky-bar');
    var trigger = document.getElementById('lym-sec-faqtabs-mobile');
    if(!bar || !trigger) return;
    function update(){
      var rect = trigger.getBoundingClientRect();
      if(rect.bottom <= 0){ bar.classList.add('lym-agr-visible'); }
      else { bar.classList.remove('lym-agr-visible'); }
    }
    window.addEventListener('scroll', update, {passive:true});
    update();
  }

  function lymAgrInitFaq(){
    var items = document.querySelectorAll('.lym-agr-accordion-item');
    items.forEach(function(item){
      var q = item.querySelector('.lym-agr-accordion-item__q');
      var a = item.querySelector('.lym-agr-accordion-answer');
      if(!q || !a) return;
      q.addEventListener('click', function(){
        var isOpen = item.classList.contains('lym-agr-active');
        items.forEach(function(other){
          if(other !== item){
            other.classList.remove('lym-agr-active');
            var oa = other.querySelector('.lym-agr-accordion-answer');
            if(oa) oa.style.maxHeight = '0px';
          }
        });
        if(isOpen){
          item.classList.remove('lym-agr-active');
          a.style.maxHeight = '0px';
        } else {
          item.classList.add('lym-agr-active');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }

  function lymPdiInitAccordion(){
    var groups = document.querySelectorAll('.lym-pdi-accordion');
    groups.forEach(function(group){
      var items = group.querySelectorAll('.lym-pdi-accordion-item');
      items.forEach(function(item){
        var q = item.querySelector('.lym-pdi-accordion-item__q');
        var a = item.querySelector('.lym-pdi-accordion-answer');
        if(!q || !a) return;
        q.addEventListener('click', function(){
          var isOpen = item.classList.contains('lym-pdi-active');
          items.forEach(function(other){
            if(other !== item){
              other.classList.remove('lym-pdi-active');
              var oa = other.querySelector('.lym-pdi-accordion-answer');
              if(oa) oa.style.maxHeight = '0px';
            }
          });
          if(isOpen){
            item.classList.remove('lym-pdi-active');
            a.style.maxHeight = '0px';
          } else {
            item.classList.add('lym-pdi-active');
            a.style.maxHeight = a.scrollHeight + 'px';
          }
        });
      });
    });
  }

  function lymAgrInitStatCounters(){
    var section = document.getElementById('lym-sec-provenbenefits-mobile');
    if(!section) return;
    var nums = section.querySelectorAll('.lym-agr-stat-card__num');
    if(!nums.length) return;
    var targets = [];
    nums.forEach(function(el){
      var target = parseInt(el.textContent, 10) || 0;
      targets.push(target);
      el.textContent = '0%';
    });
    var animated = false;
    function animate(){
      if(animated) return;
      animated = true;
      var duration = 1200;
      var start = null;
      function step(ts){
        if(!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        nums.forEach(function(el, i){
          el.textContent = Math.round(targets[i] * progress) + '%';
        });
        if(progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if('IntersectionObserver' in window){
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            animate();
            observer.disconnect();
          }
        });
      }, {threshold:0.3});
      observer.observe(section);
    } else {
      animate();
    }
  }

  window.lymAgrOpenNutritionModal = function(){
    var overlay = document.getElementById('lymNutritionModalOverlay');
    if(overlay) overlay.classList.add('lym-agr-active');
    document.body.style.overflow = 'hidden';
  };
  window.lymAgrCloseNutritionModal = function(){
    var overlay = document.getElementById('lymNutritionModalOverlay');
    if(overlay) overlay.classList.remove('lym-agr-active');
    document.body.style.overflow = '';
  };
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') window.lymAgrCloseNutritionModal();
  });

  window.lymAgrSwapHero = function(el){
    var container = el.closest('.lym-hero2-gallery, .lym-real-gallery') || el.parentElement.parentElement;
    var main = container ? container.querySelector('.lym-hero2-main-img') : document.getElementById('lymAgrHeroMain');
    if(!main) return;
    main.src = el.src;
    var thumbs = el.parentElement.querySelectorAll('.lym-hero2-thumb');
    thumbs.forEach(function(t){ t.classList.remove('lym-hero2-thumb--active'); });
    el.classList.add('lym-hero2-thumb--active');
  };

  function lymAgrInitPromoCountdown(){
    // Drives BOTH the top promo bar (.lym-promo-bar, #lymPromoHrs/#lymPromoMins/#lymPromoSecs)
    // and the mobile pricing "Fall Sale" countdown (.lym-buybox2-countdown-bar) from a
    // single shared 2-hour target end-time, so both displays stay perfectly in sync.
    var groups = [];

    var promoHrs = document.getElementById('lymPromoHrs');
    var promoMins = document.getElementById('lymPromoMins');
    var promoSecs = document.getElementById('lymPromoSecs');
    if(promoHrs && promoMins && promoSecs){
      groups.push({h:promoHrs, m:promoMins, s:promoSecs});
    }

    var buybox2Bar = document.querySelector('.lym-buybox2-countdown-bar');
    if(buybox2Bar){
      var vals = buybox2Bar.querySelectorAll('.lym-countdown-val');
      if(vals.length >= 3){
        groups.push({h:vals[0], m:vals[1], s:vals[2]});
      }
    }

    if(!groups.length) return;

    var DURATION = 2 * 60 * 60 * 1000; // 2 hours
    // Bump VERSION whenever DURATION changes. Guards against a stale end-time left in
    // sessionStorage by an earlier page load (e.g. from testing before this fix, or a
    // future duration change) that hasn't expired yet but no longer matches the current
    // intended duration — without this check that stale value would silently keep
    // counting down from wherever it was left, instead of a fresh 2 hours.
    var VERSION = 'v2-2h';
    var key = 'lymPromoCountdownEnd';
    var versionKey = 'lymPromoCountdownVersion';
    var storedVersion = sessionStorage.getItem(versionKey);
    var end = parseInt(sessionStorage.getItem(key), 10);
    var stale = storedVersion !== VERSION || !end || isNaN(end) || end < Date.now() || (end - Date.now()) > DURATION;
    if(stale){
      end = Date.now() + DURATION;
      try{
        sessionStorage.setItem(key, String(end));
        sessionStorage.setItem(versionKey, VERSION);
      }catch(e){}
    }
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function tick(){
      var remaining = end - Date.now();
      if(remaining <= 0){
        end = Date.now() + DURATION;
        try{ sessionStorage.setItem(key, String(end)); }catch(e){}
        remaining = DURATION;
      }
      var totalSec = Math.floor(remaining / 1000);
      var h = pad(Math.floor(totalSec / 3600));
      var m = pad(Math.floor((totalSec % 3600) / 60));
      var s = pad(totalSec % 60);
      groups.forEach(function(g){
        g.h.textContent = h;
        g.m.textContent = m;
        g.s.textContent = s;
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  document.addEventListener('DOMContentLoaded', function(){
    renderMini();
    renderMirror();
    renderReason();
    lymAgrInitFaq();
    lymPdiInitAccordion();
    lymAgrInitShipDate();
    lymAgrInitTimelineScroll();
    lymAgrInitPromoCountdown();
    lymAgrInitStickyBar();
    var lymAgrOnetimeBtn = document.querySelector('#pricing button[onclick*="onetime"]');
    if(lymAgrOnetimeBtn) lymAgrSetPurchaseType('onetime', lymAgrOnetimeBtn);
    lymAgrInitStatCounters();
  });
})();
